import React, { createContext, useContext } from "react";
import * as api from "../api/reportApi";

const ReportContext = createContext({ api });

export const ReportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <ReportContext.Provider value={{ api }}>
        {children}
    </ReportContext.Provider>
);

export const useReportApi = () => {
    const ctx = useContext(ReportContext);
    if (!ctx) throw new Error("useReportApi must be used in ReportProvider");
    return ctx.api;
};